import { I18nMessages } from "@/interfaces/i18n-messages";

const messages: I18nMessages = {
  pl: {
    auth: {
      loginInputPlaceholder: "login",
      passwordInputPlaceholder: "hasło",
      logInButtonText: "zaloguj się"
    },
    navbar: {
      button: {
        logOutText: "wyloguj się"
      },
      anchor: {
        aboutUs: {
          text: "o nas",
          aboutCompanyText: "o firmie",
          presentationText: "prezentacja",
          qualityText: "jakość"
        },
        news: {
          text: "aktualności",
          technicalInfoText: "porady i gwarancje",
          privacyNoticeImprintText: "polityka prywatności",
          onlineRegulationsText: "regulamin on-line"
        },
        newItemsText: "nowości",
        catalogueText: "katalog",
        promotionsText: "promocje",
        support: {
          text: "wsparcie",
          complaintFormText: "formularz reklamacyjny",
          promotionalMaterialsText: "materiały promocyjne",
          faqText: "FAQ"
        },
        contactText: "kontakt",
        shopText: "sklep"
      },
      banner: {
        logOutButtonText: "wyloguj",
        supportAnswerTimeText: "odpowiadamy na wszystkie zapytania w ciągu",
        supportTimeText:
          "oferujemy wsparcie dla naszych klientów\n" +
          "od poniedziałku do piątku w godz. 8:30-16:30",
        companyAddressHeaderText: "adres naszej firmy",
        mailSupportHeaderText: "masz pytania?",
        phoneSupportHeaderText: "zadzwoń do nas",
        technicalSupportHeaderText: "pomoc techniczna",
        loggedInSessionStatusText: "zalogowano"
      }
    },
    shared: {
      toast: {
        noFalconSessionText:
          "brak dostępu do usług Falcon.\n" + "Proszę o kontakt z DAVID Vasco",
        expiredPaymentsText: "w systemie znajdują się przeterminowane płatności"
      },
      httpError: {
        unauthorizedText: "niepoprawne dane logowania",
        uncategorizedText: "wystąpił błąd zapytania"
      },
      filterOptionsForm: {
        headerText: "filtrowanie wyników",
        dateFrom: {
          labelText: "data początkowa",
          placeholder: "od"
        },
        dateTo: {
          labelText: "data końcowa",
          placeholder: "do"
        }
      },
      sortOptionsForm: {
        headerText: "sortowanie wyników",
        sortTypeText: "typ sortowania",
        sortDirection: {
          labelText: "kierunek sortowania",
          ascendingOptionValue: "rosnąco",
          descendingOptionValue: "malejąco"
        }
      },
      paginationOptionsForm: {
        headerText: "paginacja",
        pageSizeLabelText: "wyników na stronę"
      },
      filters: {
        booleanText: {
          yesText: "tak",
          noText: "nie"
        },
        documentType: {
          invoiceText: "faktura",
          assignationText: "asygnata",
          invoiceCorrectionText: "korekta faktury"
        },
        paymentStatus: {
          unsettledText: "nierozliczona",
          settledText: "rozliczona"
        },
        documentsPaymentType: {
          noneText: "brak",
          cashText: "gotówka",
          terminalCashText: "got. term",
          checkText: "czek",
          transferText: "przelew",
          cashAndTransferText: "got./przel.",
          cashOnDeliveryText: "pobranie",
          creditCardText: "karta",
          installmentsText: "raty"
        },
        documentsPaymentStatus: {
          allText: "nieznany",
          settledText: "rozliczone",
          unsettledText: "nierozliczone",
          unsettledExpiredText: "nierozliczone - po terminie"
        },
        complaintDecisionType: {
          noneText: "brak",
          positiveText: "pozytywna",
          negativeText: "negatywna"
        },
        complaintState: {
          closedText: "zamknięta",
          openText: "otwarta",
          terminalText: "terminalowa"
        },
        complaintPositiveDecision: {
          refundText: "korekta do faktury",
          exchangeText: "wymiana części"
        },
        complaintNegativeDecision: {
          scrappingText: "złomowanie części",
          returnText: "zwrot cześci"
        },
        complaintFaultMoment: {
          beforeAssemblyText: "przed montażem",
          duringAssemblyText: "w trakcie montażu",
          duringUseText: "w trakcie eksploatacji",
          afterCollisionText: "po kolizji"
        },
        complaintFaultEntity: {
          workshopText: "warsztat",
          userText: "użytkownik"
        }
      },
      formActionButtonText: "wyświetl"
    },
    payments: {
      moduleTitleText: "płatności",
      filterOptionsForm: {
        headerText: "filtrowanie płatności",
        paymentStatus: {
          labelText: "status",
          unsettledOptionValue: "nierozliczone",
          settledOptionValue: "rozliczone"
        }
      },
      sortOptionsForm: {
        headerText: "sortowanie płatności",
        sortType: {
          createDateOptionValue: "po dacie wystawienia",
          paymentDateOptionValue: "po dacie płatności"
        }
      },
      tableColumn: {
        number: "numer",
        type: "typ",
        documentDate: "data dokumentu",
        gross: "brutto",
        paymentDate: "data płatności",
        daysLeft: "pozostało dni",
        status: "status",
        amountRemaining: "pozostało do spłaty"
      }
    },
    documents: {
      moduleTitle: {
        text: "dokumenty",
        detailsText: "szczegóły dokumentu {documentId}",
        selectComplaintDocumentText: "składanie reklamacji"
      },
      moduleSubTitle: {
        complaintCreationInfoText:
          "aby złożyć reklamację wybierz dokument a następnie produkt"
      },
      complaintCreationGuide: {
        firstStep: {
          beforeIconText: "wybierz dokument",
          afterIconText:
            "na którym znajduje się reklamowany produkt, " +
            "możesz w tym celu użyć dostępnych opcji filtrowania dokumentów"
        },
        secondStepText: "znajdź reklamowany produkt na fakturze",
        thirdStep: {
          beforeIconText: "kliknij czerwoną ikonkę",
          afterIconText: "reklamacji umieszczoną obok reklamowanego produktu"
        },
        fourthStepText:
          "staraj się uzupełnić wszystkie pola, " +
          "co pozwoli na szybkie rozpatrzenie reklamacji"
      },
      filterOptionsForm: {
        headerText: "filtrowanie dokumentów",
        documentsType: {
          labelText: "typ dokumentów",
          assignationsOptionValue: "asygnaty",
          invoicesOptionValue: "faktury",
          invoicesAndAssignationsOptionValue: "faktury i asygnaty",
          invoiceCorrectionsOptionValue: "korekty faktur"
        }
      },
      sortOptionsForm: {
        headerText: "sortowanie dokumentów",
        sortTypeCreateDateOptionValue: "po dacie wystawienia"
      },
      tableColumn: {
        functions: "podgląd dokumentu",
        number: "numer",
        type: "typ",
        documentDate: "data dokumentu",
        net: "netto",
        gross: "brutto",
        paymentType: "typ płatności",
        paymentDateDays: "termin płatności"
      },
      tableRowFunctionTitle: {
        documentDetails: "szczegóły dokumentu",
        downloadSpecification: "pobierz specyfikację",
        makeComplaint: "zareklamuj produkt"
      },
      details: {
        headerText: "dokument nr. {documentId}",
        tableColumn: {
          ordinalNumber: "lp.",
          productSymbol: "symbol towaru",
          productName: "nazwa towaru",
          quantity: "ilość",
          unitOfMeasure: "JM.",
          priceNet: "cena netto",
          priceGross: "cena brutto",
          taxValue: "VAT(%)",
          valueGross: "wartość brutto"
        }
      }
    },
    complaints: {
      moduleTitle: {
        text: "reklamacje",
        formViewText: "składanie reklamacji",
        detailsText: "składanie reklamacji - szczegóły",
        vehicleDetailsText: "składanie reklamacji - dane pojazdu",
        faultDescriptionText: "składanie reklamacji - opis wady",
        summaryText: "składanie reklamacji - podsumowanie"
      },
      filterOptionsForm: {
        headerText: "filtrowanie reklamacji",
        complaintState: {
          labelText: "stan reklamacji",
          closedOptionValue: "zamknięte",
          openOptionValue: "otwarte",
          terminalOptionValue: "terminalowe"
        }
      },
      sortOptionsForm: {
        headerText: "sortowanie reklamacji",
        sortTypeCreateDateOptionValue: "po dacie wystawienia"
      },
      tableColumn: {
        number: "numer",
        productSymbol: "symbol produktu",
        quantity: "ilość",
        decisionType: "typ decyzji",
        createDate: "data utworzenia",
        closeDate: "data rozpatrzenia",
        state: "stan reklamacji"
      },
      creationForm: {
        navigationStepButton: {
          nextText: "dalej",
          previousText: "wróć",
          summaryText: "podsumowanie"
        },
        details: {
          headerText: "szczegóły reklamacji",
          dateProductDeliveryLabelText: "data dostarczenia towaru z magazynu",
          serialNumberLabelText: "numer seryjny towaru - jeżeli znany",
          quantityLabelText: "ilość reklamowanych sztuk",
          decisionPositiveLabelText: "przy pozytywnie rozpatrzonej reklamacji",
          decisionNegativeLabelText: "przy negatywnie rozpatrzonej reklamacji",
          faultDetectionMomentLabelText: "moment stwierdzenia usterki",
          faultFoundByLabelText: "kto stwierdził usterkę?",
          refuseAddCostsLabelText: "zlecam odbiór kurierem",
          compensationValueLabelText: "kwota oczekiwanej rekompensaty",
          compensationCurrencyLabelText: "waluta rekompensaty"
        },
        vehicleDetails: {
          header: {
            text: "dane pojazdu",
            vehicleText: "szczegółowe dane pojazdu",
            installationText: "dane na temat montażu",
            uninstallationText: "dane na temat demontażu"
          },
          registerNumberLabelText: "numer rejestracyjny",
          engineNumberLabelText: "numer silnika",
          vinNumberLabelText: "numer VIN - jeżeli znany",
          brandVehicleLabelText: "marka pojazdu",
          productionYearLabelText: "rok produkcji pojazdu",
          engineCapacityLabelText: "pojemność silnika",
          powerValueLabelText: "moc pojazdu",
          powerUnitLabelText: "jednostka mocy pojazdu",
          workshopInstallNameLabelText: "nazwa warsztatu",
          workshopInstallAddressLabelText: "adres warsztatu",
          installedByLabelText: "kto montował?",
          counterStateInstallLabelText: "stan licznika na dzień montażu",
          installationDateLabelText: "data montażu",
          workshopUninstallNameLabelText: "nazwa warsztatu",
          workshopUninstallAddressLabelText: "adres warsztatu",
          uninstalledByLabelText: "kto demontował?",
          counterStateUninstallLabelText: "stan licznika na dzień demontażu",
          uninstallationDateLabelText: "data demontażu"
        },
        faultDescription: {
          headerText: "opis wady",
          labelText: "dokładny opis wady w wybranym towarze"
        },
        summary: {
          newComplaint: {
            alert: {
              headerText: "uwaga",
              text:
                "kliknięcie poniższego przycisku spowoduje utworzenie nowej reklamacji"
            },
            buttonText: "złóż reklamację"
          }
        }
      }
    }
  }
};
export default messages;
